module.exports = __webpack_public_path__ + "static/img/nav_bg.a1850719.png";